import { render } from "./AdmDataTable.vue?vue&type=template&id=608db458&scoped=true"
import script from "./AdmDataTable.vue?vue&type=script&lang=js"
export * from "./AdmDataTable.vue?vue&type=script&lang=js"

import "./AdmDataTable.vue?vue&type=style&index=0&id=608db458&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608db458"]])

export default __exports__